module.exports = __webpack_public_path__ + "img/img-review.76de851c.png";